import * as React from "react";
import {
  Select,
  FormControl,
  MenuItem,
  InputAdornment,
  IconButton,
} from "@mui/material";
import ClearIcon from "@mui/icons-material/Clear";
import { useState } from "react";

export default function CustomDropdown({
  width,
  height,
  optionsToSend,
  optionsToDisplay,
  updateSelect,
  dropDownId,
  defaultValue,
  fontSize,
  disabled,
  isClearable, 
  placeholder,
  isDefaultOpen
}) {
  const [data, setData] = useState(defaultValue);
  const [isOpen, setIsOpen] = useState(isDefaultOpen || false); 
  React.useEffect(() => {
    setData(defaultValue);
  }, [defaultValue]);

  const handleChange = (event) => {
    setData(event.target.value);
    const idx = optionsToDisplay.indexOf(event.target.value);
    updateSelect(dropDownId, optionsToSend[idx]);
  };

  const handleClear = () => {
    setData("");
    updateSelect(dropDownId, null);
  };

  return (
    <FormControl sx={{ width: { width }, height: { height } }}>
      <Select
        onChange={handleChange}
        variant="outlined"
        value={data}
        open={isOpen} // Control the open state
        onClose={() => setIsOpen(false)} // Close handler
        onOpen={() => setIsOpen(true)} // Open handler
        
        displayEmpty 
        placeholder={placeholder}
        renderValue={(selected) => {
          if (!selected) {
            return <span style={{ opacity: "0.5", fontSize: "16px" }}>{placeholder}</span>;
          }
          const found = optionsToDisplay.includes(selected);
          return found ? selected : data;

        }}
        endAdornment={
          isClearable && data && (
            <InputAdornment position="end">
              <IconButton
                aria-label="clear selection"
                onClick={handleClear}
                edge="end"
                size="small"
                sx={{
                  width: 14,
                  height: 14,
                }}
                style={{paddingRight:"30px"}}
              >
                <ClearIcon sx={{ fontSize: 14 }} />
              </IconButton>
            </InputAdornment>
          )
        }
        sx={{
          boxShadow: "none",
          width: { width },
          height: { height },
          fontWeight: "400",
          opacity: "0.85",
          padding: "none",
          fontFamily: "Poppins",
          textTransform: "none",
          background: "white",
          fontSize: [fontSize],
          lineHeight: "20px",
          color: "black",
        }}
        disabled={disabled}
      >
        {optionsToDisplay?.map((val, index) => (
          <MenuItem
            key={index}
            value={val}
            sx={{
              fontSize: [fontSize],
              fontWeight: "400",
              opacity: "0.85",
                  textTransform: "lowercase",
              fontFamily: "Poppins",
                  textTransform: "none",
              lineHeight: "20px",
              color: "black",
            }}
          >
            {val}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}

CustomDropdown.defaultProps = {
  width: "100%",
  height: "36px",
  fontSize: "1rem",
  updateSelect: () => {},
  optionsToDisplay: [],
  optionsToSend: [],
  dropDownId: "",
  defaultValue: "",
  isClearable: false,
};
